<template>
    <div class="border bg-gray-100 rounded p-4 mt-3">
        <div class="mb-4">Author Quote</div>
            <div
                class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
            >
                <p class="text-gray-700 mb-4">Author</p>
                <reference
                    create-text="Create new Author and link Author to this page"
                    link-text="Link an existing Author"
                    v-model="data.author"
                    :creatable="false"
                    :editable="true"
                    :language="language"
                    field-name="author"
                    model-data="Author"
                    :should-open-new-window="true"
                    :query="{
                        status_id: 1,
                    }"
                    @input="updateAuthor($event)"
                    :error="errorBag['author_id'] ? errorBag['author_id'][0] : null"
                />
            </div>

            <input-rich-text
                label="* Quote"
                name="quote"
                :language="language"
                v-model="data.quote"
                :maxlength="60000"
                 :error="errorBag['quote'] ? errorBag['quote'][0] : null"
                :toolbarButtons="[]"
            ></input-rich-text>
        </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    name: "AuthorQuote",
    props: {
        value: [Object, Array],
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
        contentBlockId: Number,
        contentSectionId: Number,
        errorBag: {
            type: [Object, Array],
            required: false,
        },
    },
    data() {
        return {
            data: {
                author: this.value?.author ?? null,
                author_id: this.value?.author_id ?? null,
                quote: this.value?.quote ?? null,
            },
        };
    },
    methods: {
        updateAuthor: function (author) {
            this.data.author_id = author?.id || null;
        },
    },
    updated() {
        this.$emit("input", this.data);
    },
    watch: {
        value: function (newValue) {
            this.data = newValue;
        }
    }
};
</script>
